const columns = [
    {
        title: 'Wallet Account No.',
        dataIndex: 'walletAccountNo',
    },
    {
        title: 'Withdraw Type',
        dataIndex: 'withdrawType',
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter: true,
    },
    {
        title: 'Action Date',
        dataIndex: 'actionDate',
        sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'requestStatus',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    },
];

export default columns;
